import { render, staticRenderFns } from "./LoadAttachment.vue?vue&type=template&id=67e1ca94&scoped=true&"
import script from "./LoadAttachment.vue?vue&type=script&lang=ts&"
export * from "./LoadAttachment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e1ca94",
  null
  
)

export default component.exports